import { getCompassByKey } from '@sailor/compass';
import {
  getBrowserSystemLanguage, getCityId, getEnv, getLanguage, getPassportApiHost, getRegion,
} from '@m2h/common/utils';

interface DomainKeyConfig {
  compassKey: string;
  env: string;
}

// Native SLCompass exposes platform-host keys, while Web Compass uses canonical keys.
// Keep the compatibility mapping in the bridge so business code stays platform agnostic.
// Compass sync: https://km.sankuai.com/collabpage/2709136291
// Compass config contract: https://km.sankuai.com/collabpage/2776906537
// Add legacy aliases only after their key, environment, and return shape are verified.
const domainKeyConfigMap: Record<string, DomainKeyConfig> = {
  'Passport.testUrl': {
    compassKey: 'passportApiHost',
    env: 'test',
  },
  'Passport.url': {
    compassKey: 'passportApiHost',
    env: 'prod',
  },
};

const SLCompass = {
  getRegionInfo() {
    return {
      openSARegion: {
        homePage: true,
        addressSelectPageNew: true,
      },
    };
  },
  getCompassInfo() {
    return {
      region: getRegion(),
      cityId: getCityId(),
    };
  },
  getDomainByCompassKey(key: string) {
    if (typeof key !== 'string' || !key) return '';

    try {
      const keyConfig = domainKeyConfigMap[key];
      const compassKey = keyConfig?.compassKey || key;
      const env = keyConfig?.env || getEnv();

      const result = compassKey === 'passportApiHost'
        ? getPassportApiHost()
        : getCompassByKey({
          key: compassKey,
          env,
          region: getRegion(),
        });
      return typeof result === 'string' ? result : '';
    } catch (e) {
      console.warn('SLCompass.getDomainByCompassKey failed', e);
      return '';
    }
  },
  currentCompassInfo() {
    return {
      ...SLCompass.getCompassInfo(),
      locale: getLanguage(),
      sysLocale: getBrowserSystemLanguage(),
    };
  },
};

export default SLCompass;
